import initApi from './init';
import client, { createClient } from './client';

initApi();

export default client;

export { createClient };
